const postalCodeField = {
  component: 'TextField',
  maxLength: 15,
};

export default postalCodeField;
